export const GUIDES_FETCH_REQUESTED = 'GUIDES_FETCH_REQUESTED'
export const GUIDES_FETCH_SUCCESS = 'GUIDES_FETCH_SUCCESS'
export const GUIDES_FETCH_FAILED = 'GUIDES_FETCH_FAILED'

export const GUIDE_COMPLETED_REQUESTED = 'GUIDE_COMPLETED_REQUESTED'
export const GUIDE_COMPLETED_SUCCESS = 'GUIDE_COMPLETED_SUCCESS'
export const GUIDE_COMPLETED_FAILED = 'GUIDE_COMPLETED_FAILED'

export const GUIDES_COMPLETED_REQUESTED = 'GUIDES_COMPLETED_REQUESTED'

export const GUIDES_RETAKE = 'GUIDES_RETAKE'
